import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../../ui/dialog';
import { haccpApi, erroreHaccp } from '../haccpApi';
import { EliminaDocumento } from './EliminaDocumento';

const CAMPO = 'mt-1 w-full h-11 px-3 rounded-lg border border-gray-300 text-sm text-gray-900 bg-white';

export const ModificaDocumento = ({ documento, titolo, conStorico, voci = [], persone = [], onClose, onSalvato }) => {
  const [form, setForm] = useState({});
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (documento) setForm({ tipo: documento.tipo, persona_id: documento.persona_id || '', data_documento: documento.data_documento || '', scadenza: documento.scadenza || '', ente: documento.ente || '', note: documento.note || '' });
  }, [documento]);
  // con persona: solo attestati; senza persona si può scegliere anche un attestato e poi di chi è
  const tipi = documento?.persona_id ? voci.filter((v) => v.per_persona) : voci;
  const scelta = voci.find((v) => v.codice === form.tipo);
  const manca = !!scelta?.per_persona && !form.persona_id;
  const occupato = (form.tipo !== documento?.tipo || form.persona_id !== (documento?.persona_id || '')) && (scelta?.per_persona
    ? scelta.persone?.some((r) => r.persona.id === form.persona_id && r.documento && r.documento.id !== documento?.id)
    : scelta?.documento && scelta.documento.id !== documento?.id);

  const esegui = async (fai, messaggio) => {
    setBusy(true);
    try { await fai(); toast.success(messaggio); onSalvato(); onClose(); }
    catch (e) { toast.error(erroreHaccp(e, 'Operazione non riuscita')); }
    finally { setBusy(false); }
  };
  const salva = () => esegui(() => haccpApi.put(`/documenti/${documento.id}`, {
    data_documento: form.data_documento || null, scadenza: form.scadenza || null, ente: form.ente || null, note: form.note || null,
    ...(form.tipo !== documento.tipo ? { tipo: form.tipo } : {}),
    ...(scelta?.per_persona && form.persona_id !== (documento.persona_id || '') ? { persona_id: form.persona_id } : {}),
  }), 'Documento aggiornato');
  const eliminato = () => { onSalvato(); onClose(); };

  return (
    <Dialog open={!!documento} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md rounded-2xl" data-testid="documento-modifica-dialog">
        <DialogHeader>
          <DialogTitle className="pr-6">{titolo}</DialogTitle>
          <DialogDescription>Correggi date e dati del documento caricato, oppure eliminalo.</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          {!documento?.archiviato && (
            <label className="text-xs text-gray-600 col-span-2">Che documento è
              <select value={form.tipo || ''} onChange={(e) => setForm({ ...form, tipo: e.target.value })} className={CAMPO} data-testid="documento-modifica-tipo">
                {tipi.map((v) => <option key={v.codice} value={v.codice}>{v.nome}</option>)}
                <option value="altro">Altro documento</option>
              </select>
              {scelta?.per_persona && (
                <select value={form.persona_id || ''} onChange={(e) => setForm({ ...form, persona_id: e.target.value })} className={CAMPO} data-testid="documento-modifica-persona">
                  <option value="">Di chi è?</option>
                  {persone.filter((p) => p.attivo !== false || p.id === form.persona_id).map((p) => <option key={p.id} value={p.id}>{p.nome}</option>)}
                </select>
              )}
              {manca && <span className="mt-1 block text-[11px] text-amber-700" data-testid="documento-modifica-persona-avviso">Scegli la persona: chi non c'è lo aggiungi da Persone.</span>}
              {occupato && <span className="mt-1 block text-[11px] text-amber-700" data-testid="documento-modifica-tipo-avviso">
                {voci.find((v) => v.codice === form.tipo)?.con_storico ? 'C\'è già un documento: il più vecchio va nelle versioni precedenti.' : 'Sostituisce quello che c\'è già: il vecchio verrà eliminato per sempre.'}
              </span>}
            </label>
          )}
          <label className="text-xs text-gray-600">Data del documento
            <input type="date" value={form.data_documento || ''} onChange={(e) => setForm({ ...form, data_documento: e.target.value })} className={CAMPO} data-testid="documento-modifica-data" />
          </label>
          <label className="text-xs text-gray-600">Scadenza
            <input type="date" value={form.scadenza || ''} onChange={(e) => setForm({ ...form, scadenza: e.target.value })} className={CAMPO} data-testid="documento-modifica-scadenza" />
          </label>
          <label className="text-xs text-gray-600 col-span-2">Rilasciato da
            <input value={form.ente || ''} onChange={(e) => setForm({ ...form, ente: e.target.value })} className={CAMPO} data-testid="documento-modifica-ente" />
          </label>
          <label className="text-xs text-gray-600 col-span-2">Note
            <input value={form.note || ''} onChange={(e) => setForm({ ...form, note: e.target.value })} className={CAMPO} data-testid="documento-modifica-note" />
          </label>
        </div>
        <div className="flex gap-2 justify-between">
          {documento && <EliminaDocumento documento={documento} nome={titolo} onEliminato={eliminato} testid="documento-elimina"
            avviso={documento.tipo === 'altro' ? 'Sparisce dagli altri documenti.' : conStorico ? 'Se c\'è, torna valida la versione precedente.' : 'La voce torna da caricare.'} />}
          <button onClick={salva} disabled={busy || manca} className="h-10 px-5 rounded-full bg-gray-900 text-white text-sm font-semibold flex items-center gap-2 disabled:opacity-50" data-testid="documento-modifica-salva">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />}Salva
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
